import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var MagnifySearchSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M21.414 18.586l-3.978-3.978c-.323-.323-.38-.822-.186-1.235A7.95 7.95 0 0018 10a7.944 7.944 0 00-2.344-5.656A7.94 7.94 0 0010 2a7.94 7.94 0 00-5.656 2.344A7.94 7.94 0 002 10a7.94 7.94 0 002.344 5.656A7.94 7.94 0 0010 18a7.95 7.95 0 003.373-.75c.414-.194.912-.137 1.235.186l3.978 3.977c.377.379.88.587 1.414.587.534 0 1.037-.208 1.414-.586.378-.378.586-.879.586-1.414 0-.534-.208-1.036-.586-1.414z", fill: "currentColor" })] })));
};

export { MagnifySearchSolidIcon };
//# sourceMappingURL=MagnifySearchSolidIcon.js.map
